import { Callout } from 'bricks-ui/packages/bricks-ui';

export default Callout;
